<template>
  <v-app>
    <v-main>
      <v-container fluid fill-height class="login-layout">
        <v-row align="center" justify="center" no-gutters>
          <v-col cols="12" sm="8" md="6" lg="5" xl="3">
            <router-view></router-view>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data: () => ({
    drawer: null
  }),
  props: {
    source: String
  }
};
</script>

<style scoped>
.login-layout {
  background-color: #3b3b3b;
}
</style>
